var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVilla = function SvgVilla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Villa")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Villa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-house-retro@24x24",
    transform: "translate(34.000000, 35.000000)",
    stroke: "#212121",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "76.6609651 40.2901554 76.6609651 78.6149374 59.952806 78.6149374"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.91416443 40.2901554 4.91416443 78.6149374 21.6223235 78.6149374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.8111617 1.96537344 21.6223235 1.96537344 21.6223235 12.7749273 10.8111617 12.7749273"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.86266309,
    y1: 1.96537344,
    x2: 24.5708221,
    y2: 1.96537344,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "59.952806 1.96537344 70.7639678 1.96537344 70.7639678 12.7749273 59.952806 12.7749273"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.0043074,
    y1: 1.96537344,
    x2: 73.7124664,
    y2: 1.96537344,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7414851,40.2901554 L81.5751295,40.2901554 L77.0286101,17.199376 C76.52304,14.6276194 74.2985317,12.7749273 71.7165131,12.7749273 L51.1073101,12.7749273",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8336445,40.2901554 L0,40.2901554 L4.54651946,17.199376 C5.05208954,14.6276194 7.27659787,12.7749273 9.85861647,12.7749273 L30.4678195,12.7749273",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "59.952806 26.1737827 59.952806 78.6149374 21.6223235 78.6149374 21.6223235 26.1737827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8669705,32.4286617 L44.6642945,5.15958344 C42.8551539,2.71642143 39.4334395,2.22263002 37.0200387,4.05408027 C36.6050648,4.36730617 36.2374125,4.73949224 35.9280022,5.15958344 L15.7253262,32.4286617",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1416443,78.6149374 L32.4334852,78.6149374 L32.4334852,56.602755 C32.4334852,53.5650738 34.9285703,51.0997093 38.0028716,51.0997093 L43.5722579,51.0997093 C46.6465592,51.0997093 49.1416443,53.5650738 49.1416443,56.602755 L49.1416443,78.6149374 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 78.6149374,
    x2: 81.5751295,
    y2: 78.6149374,
    id: "Path"
  })))));
};
export default SvgVilla;